<template>
<v-main style="padding-bottom:130px;">
  <v-card class="mx-0" color="#294A66" tile dark>
    <v-card-actions>
      <v-img
        class="preview-item-file mr-1"
        :src="logoSrc"
        alt=""
        width="50px"
      />
      <v-card-text class="pa-0">
        <h3 style="color:white;" class="font-weight-bold text-h4"><span v-text="basetitle" v-if="basetitle"></span></h3>
        <p class="my-0 text-caption text-right text-body1">メンバー {{members.length}}人 Lid数 {{lid.length}}</p>
      </v-card-text>
    </v-card-actions>
  </v-card>
  <v-card @click="authModal = true" color="#FFB336" tile height="" width="100%" style="" v-if="!isAuthed">
    <p class="mb-0 text-center">現在未ログイン状態で閲覧しています。<br/>ここをタップして始めてください</p>
  </v-card>


  <v-container>
    <div class="mx-4" style="border-bottom:solid #707070;">
      <p class="d-flex mb-2" v-if="page==='zentei'"><span class="ink--text mr-auto">{{$t('前提情報')}}</span><span class="flex-column"><span class="cloud--text text-caption">更新日時</span><br><span class="cloud--text text-caption" v-if="contentUpdatedAt" v-text="contentUpdatedAt"></span></span></p>
      <p class="d-flex mb-2" v-if="page==='offline'"><span class="ink--text mr-auto">スケジュール</span><span class="flex-column"><span class="cloud--text text-caption">更新日時</span><br><span class="cloud--text text-caption" v-if="config.home_meetingTime" v-text="config.home_meetingTime.toDate().toLocaleString().slice(0,-3)"></span></span></p>
      <p class="d-flex mb-2" v-if="page==='news'"><span class="ink--text mr-auto">お知らせ</span><span class="flex-column"><span class="cloud--text text-caption">更新日時</span><br><span class="cloud--text text-caption" v-if="contentUpdatedAt" v-text="contentUpdatedAt"></span></span></p>
      <p class="d-flex mb-2" v-if="page==='map'"><span class="ink--text mr-auto">地図情報</span></p>
      <p class="d-flex mb-2" v-if="page==='lids'"><span class="ink--text mr-auto">各Lid情報</span></p>
    </div>
    <div v-if="page==='zentei'||page=='news'">
      <RichViewAndEditor lidId="home" :key="page" :pageType="page" @updateDate="(date)=>{contentUpdatedAt=date}" ></RichViewAndEditor>
    </div>
    <div v-if="page==='zentei'||page=='news'">
      <PDFViewAndSelector lidId="home" :key="page" :pageType="page"></PDFViewAndSelector>
    </div>
    <div class="mx-4 mt-2 mb-12 qimg" v-else-if="page==='offline'">
      <v-row>
        <!--
          カレンダー
        <v-col cols="5">
          <v-sheet height="600">
            <v-calendar
              ref="calendar"
              v-model="value"
              :weekdays="[1,2,3,4,5,6,0]"
              type="month"
              :events="events"
              event-overlap-mode="stack"
              :event-overlap-threshold="30"
              :event-color="getEventColor"
              @change="getEvents"
            ></v-calendar>
          </v-sheet>
        </v-col>-->
        <v-btn class="mx-auto my-2" color="#99D1FF" width="80%" @click="mtgId = 'new',editMtg=true" v-if="isAdmin&&false">新規予定追加</v-btn>
        <v-col cols="12" v-if="mtgs.length>0">
          <v-card class="my-2" v-for="mtg in mtgs" :key="mtg.sort" color="#CCE8FF" @click="mtgTitle=mtg.mtgTitle,mtgSummary=mtg.mtgSummary,mtgIs=mtg.mtgIs,mtgLinkFont=mtg.mtgLinkFont,mtgInCharge=mtg.mtgInCharge,mtgDateStart=mtg.mtgDateStart,mtgDateEnd=mtg.mtgDateEnd,mtgId = mtg.sort,mtgContent=true">
            <v-card-actions>
              <v-row>
                <v-col cols="3" class="my-auto">
                  <v-img src="../../assets/とにかく始める_議論.svg" width="100%"></v-img>
                  <v-chip class="white--text" color="#707070" v-if="mtg&&mtg.mtgIs==='before'">募集開始前</v-chip>
                  <v-chip class="white--text" color="#BA0009" v-else-if="mtg&&mtg.mtgIs==='now'">募集中</v-chip>
                  <v-chip class="" color="#707070" v-else-if="mtg&&mtg.mtgIs==='after'">募集終了</v-chip>                  
                </v-col>                
                <v-col cols="9" class="my-auto">
                  <div class="d-flex flex-column text-center">
                    <h3 class="mt-0" v-if="mtg&&mtg.mtgTitle" v-text="mtg.mtgTitle"></h3>
                    <p class="mb-0"><span v-if="mtg&&mtg.mtgInCharge" v-text="mtg.mtgInCharge"></span></p>
                    <p class="mb-0">
                      実施日:{{ dateFormatter(mtg.mtgDateStart, mtg.mtgDateEnd) }}
                    </p>
                  </div>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>            
        </v-col>
        <v-col cols="12" v-else>
          <p class="text-center">スケジュール情報が登録されていません。</p>
        </v-col>
      </v-row>
    </div>
    <div v-else-if="page==='map'" class="mt-2 mb-12">
      <l-map ref="map" style="height:600px; width:90%; z-index:3" :zoom="15" :center="[locate.lat, locate.lng]" class="mx-auto">
        <l-tile-layer :url="'http://{s}.tile.osm.org/{z}/{x}/{y}.png'" :attribution="attribution"></l-tile-layer>
        <Vue2LeafletMarkerCluster>
          <l-marker
            v-for="(item, index) in showedIdeaInMap_dict" :key="index" :lat-lng="[item.latlngInputLat, item.latlngInputLng]" :icon="item.icon"
          >
            <l-popup :options="{offset: [3,-26]}">
              <div class="primary--text">{{item.content}} ({{item.timeday}}:{{namelist[item.author]}})</div>
              <!-- <div v-for="(title, index) in marker.titles"
              :key="'tit-'+index">
                <a :href="title.uri" target="_blank">{{title.title}}</a>
              </div> -->
            </l-popup>  
          </l-marker>
          <!-- config.placeLayerに配置した情報提供用の位置情報ピン -->
          <l-marker
            v-for="(place, index) in config.placeLayer" :key="index" :lat-lng="[place.lat, place.lon]" :icon="getIconWithColor(place.color, 'pin')"
          >
            <l-popup :options="{offset: [13,-24]}">
              <div><h3 class="primary--text">{{place.name}}</h3><p v-if="place.desc" class="body1">{{place.desc}}</p></div>
            </l-popup>  
          </l-marker>
        </Vue2LeafletMarkerCluster>
      </l-map>
      <div class="shallowCloud ma-2 pa-1">
        <h3 class="text-center">{{$t('アイデア')}}の位置情報表示</h3>
        <v-row class="my-2">
          <v-col cols="12" v-for="(item, index) in lid.concat(alid)" :key="index">
            <v-checkbox
              v-model="mapLid"
              :label="item.title"
              :value="item.id"
              hide-details
              multiple
            ></v-checkbox>                
          </v-col>
        </v-row>
        <div class="d-flex">
          <v-btn class="mx-auto my-2 white--text" color="deepAqua" :disabled="mapLid.length===0" @click="getIdea()">表示</v-btn>
        </div>
      </div>
    </div>
    <p v-else-if="page!=='lids'" class="text-center mt-16 ink--text">まだ投稿されていません。</p>
    <v-row v-else>
      <v-col v-for="item in navlid" :key="item.id" cols="12">
      <router-link :to="'/sp/'+item.id+'/idea'" style="text-decoration:none;">
        <v-card
          class="mx-2 my-2 pa-2"
          style="border-radius: 10px;"
          elevation="2"
          color="abyss"
        >
          <v-card-actions>
            <v-chip v-if="isAdmin||(item.lidAdmin.includes(uid)&&card.sanka)" class="px-2" color="faintHoney" outlined label>管理者</v-chip>
            <v-chip v-else-if="item.sanka" class="px-2" color="algae" outlined label>参加中</v-chip>
            <v-chip v-else class="px-2" color="white" outlined label>未参加</v-chip>
            <v-spacer></v-spacer>
          </v-card-actions>
          <v-card-actions class="ml-1">
            <v-img src="../../assets/png/rectangle3.png" max-width="10px"></v-img>
            <v-card-title style="color:white;" class="pa-2">{{item.title}}</v-card-title>     
          </v-card-actions>
          <v-divider class="mx-2" color="white"></v-divider>
          <v-row class="mt-2">
            <v-col cols="6" class="pa-2">
              <v-card-text class="py-0 pr-0" style="color:white; font-size:10px;">このLidのメンバー</v-card-text>
              <v-card-title class="pt-0 pr-0 d-flex align-baseline" style="color:white">
                <span v-if="item.counter&&item.counter.member>=0" v-text="item.counter.member"></span><span class="text-caption pl-2">人</span> 
              </v-card-title>          
            </v-col>

            <v-col cols="6" class="pa-2">
              <v-card-text class="py-0 px-0" style="color:white; font-size:10px;">アクティブユーザー数(本日)</v-card-text>
              <v-card-title class="pt-0 px-0 d-flex align-baseline" style="color:white"><span v-if="(item.counter&&item.counter.activeUser>=0&&yyyymmdd===item.counter.day)" v-text="item.counter.activeUser"></span><span v-else>0</span><span class="text-caption pl-2">人</span></v-card-title>
            </v-col>          
          </v-row>        
          <v-row>
            <v-col cols="6" class="pa-2">
              <v-card-text class="py-0 pr-0" style="color:white; font-size:10px;">今まで投稿された{{$t('アイデア')}}数</v-card-text>
              <v-card-title class="pt-0 pr-0 d-flex align-baseline" style="color:white"><span v-if="item.counter&&item.counter.idea>=0" v-text="(item.counter.idea)"></span><span class="text-caption pl-2">件</span></v-card-title>            
            </v-col>

            <v-col cols="6" class="pa-2">
              <v-card-text class="py-0 px-0" style="color:white; font-size:10px;">作成された{{$t('プロジェクト')}}数</v-card-text>
              <v-card-title class="pt-0 px-0 d-flex align-baseline" style="color:white"><span v-if="(item.counter&&item.counter.project>=0)" v-text="item.counter.project"></span><span class="text-caption pl-2">件</span></v-card-title>          
            </v-col>
          </v-row>
          <p class="my-0" v-if="false">あなたはこのLidに参加していません。</p>
        </v-card>
      </router-link>
      </v-col>
    </v-row>
  </v-container>

  <v-navigation-drawer
    v-model="drawer"
    fixed
    style="background-color:#DCDCDC"
  >
    <navi></navi>
  </v-navigation-drawer>

  <!--アクションボタン-->
  <v-speed-dial
    direction="top"
    transition="slide-x-reverse-transition"
    class="add-btn"
  >
    
    <template v-slot:activator>
      <v-btn color="#008CFF" dark fab @click="overlay = true">
        <v-icon large dark>mdi-menu-up</v-icon>
      </v-btn>
    </template>
    <v-overlay
      :z-index="zIndex"
      :value="overlay"
      :opacity="0.8"
    >
    </v-overlay>
    
    <v-card color="rgb(0,0,0,0)" elevation="0" class="d-flex flex-column align-end">
      <v-card-actions class="pr-0 py-1">
        <div style="color:white; font-size:20px; white-space:nowrap;">前提情報</div>
        <v-btn icon rounded height="50" width="50" style="background-color:#294A66 !important;" @click="overlay = false, page='zentei'"><v-img width="50px" contain height="35px" src="../../assets/svg/information.svg"></v-img></v-btn>
      </v-card-actions>
      <v-card-actions class="pr-0 py-1">
        <div style="color:white; font-size:20px; white-space:nowrap;">スケジュール</div>
        <v-btn icon rounded height="50" width="50" style="background-color:#294A66 !important;" @click="overlay = false, page='offline'"><v-img width="50px" contain height="35px" src="../../assets/svg/offline_mtg.svg"></v-img></v-btn>
      </v-card-actions>
      <v-card-actions class="pr-0 py-1">
        <div style="color:white; font-size:20px; white-space:nowrap;">お知らせ</div>
        <v-btn icon rounded height="50" width="50" style="background-color:#294A66 !important;" @click="overlay = false, page='news'"><v-img width="50px" contain height="35px" src="../../assets/svg/notification.svg"></v-img></v-btn>
      </v-card-actions>
      <v-card-actions class="pr-0 py-1">
        <div style="color:white; font-size:20px; white-space:nowrap;">マップ</div>
        <v-btn icon rounded height="50" width="50" style="background-color:#294A66 !important;" @click="overlay = false, page='map',setLocate()"><v-img width="50px" contain height="35px" src="../../assets/svg/map.svg"></v-img></v-btn>
      </v-card-actions>
      <v-card-actions class="pr-0 py-1">
        <div style="color:white; font-size:20px; white-space:nowrap;">Lid情報</div>
        <v-btn icon rounded height="50" width="50" style="background-color:#294A66 !important;" @click="overlay = false, page='lids'"><v-img width="50px" contain height="35px" src="../../assets/svg/each_lid.svg"></v-img></v-btn>
      </v-card-actions>
    </v-card>
  </v-speed-dial>
  


  <!--サインイン画面-->
  <v-dialog fullscreen v-model="authModal">
    <auth-view
      v-if="authModal"
      :defaultView="defaultAuthView"
      @closeModal="closeAuthModal"
    >
    </auth-view>
  </v-dialog>

  <!--通知画面-->
  <v-dialog fullscreen v-model="notify" class="pa-0">
    <notifySp @close="closeNotify()"></notifySp>
  </v-dialog>

  <div style="position:fixed;bottom:0px;width:100%; z-index:4;">
    <v-card class="mb-0">
      <p class="text-center mb-0 text">{{$t('アイデア')}}テーマ一覧</p>
      <v-chip-group
        class="mx-2 pb-2"
        active-class="primary--text"
      >
        <v-chip
          v-for="item in navlid"
          :key="item.id"
          :to="'/sp/'+item.id+'/idea'"
          label
          outlined
          style="border-left: 0.3rem solid #294A66; border-top: 0.1rem solid #000000; border-right: 0.1rem solid #000000; border-bottom: 0.1rem solid #000000;"
        >
          {{item.title}}
        </v-chip>
      </v-chip-group>
    </v-card>
    <v-bottom-navigation
      grow
     
      :value="1"
    >
      <v-btn @click="drawer = !drawer">
        <span>メニュー</span>
        <v-icon>mdi-menu</v-icon>
      </v-btn>

      <v-btn>
        <span>ホーム</span>
        <v-icon>mdi-home</v-icon>
      </v-btn>

      <v-btn @click="notify=true">
        <span>通知</span>
        <v-icon>mdi-bell</v-icon>
      </v-btn>
    </v-bottom-navigation>    
  </div>

  <v-dialog v-model="mtgContent" width="100vw" fullscreen>
    <v-card color="white">
      <v-card-actions>
        <v-chip class="white--text" color="#707070" v-if="mtgIs==='before'">募集開始前</v-chip>
        <v-chip class="white--text" color="#BA0009" v-else-if="mtgIs==='now'">募集中</v-chip>
        <v-chip class="" color="#707070" v-else-if="mtgIs==='after'">募集終了</v-chip>
        <v-spacer></v-spacer>
        <v-icon @click="mtgContent = false" color="#ba0009">mdi-close</v-icon>
      </v-card-actions>
      <v-row class="pa-2">
        <v-col cols="12" class="d-flex flex-column">
          <h2 v-if="mtgTitle" v-text="mtgTitle" class="my-4 text-center"></h2>
          <v-divider></v-divider>
          <p class="mb-0 text-center"><span v-if="mtgInCharge" v-text="mtgInCharge"></span></p>
          <p class="mb-0">
            実施日:{{ dateFormatter(mtgDateStart, mtgDateEnd) }}
          </p>
        </v-col>
        <v-col cols="12">
          <p v-if="mtgSummary" v-text="mtgSummary"></p>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>

</v-main>
</template>

<script>
import Vue from 'vue'
import firebase from 'firebase'
import navi from './sp_navigator.vue'
import notifySp from './sp_notification.vue'
// import authView from '../../components/auth/authView.vue';
const authView = () => import('../../components/auth/authView.vue')
import RichViewAndEditor from '../../components/RichViewAndEditor.vue';
import PDFViewAndSelector from '../../components/PDFViewAndSelector.vue';
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'pc' // customize this for SSR
})

import 'leaflet/dist/leaflet.css'
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';
import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

export default {
  components: {
    authView,
    RichViewAndEditor,
    navi,
    notifySp,
    LMap, 
    LTileLayer,
    LMarker,
    LPopup,
    PDFViewAndSelector,
    Vue2LeafletMarkerCluster
  },
  data: () => ({
    drawer: false,
    ideatf:false,
    pjtf:false,
    notify: false,
    db: null,
    showedIdeaInMap_dict: [],
    idea:[],
    mapLid:[],
    now: "",
    mtgs: [],
    mtgId: "new",
    editMtg: false,
    mtgContent: false,
    mtgTitle: "",
    mtgSummary: "",
    mtgInCharge: "",
    mtgLinkFont: "",
    mtgDateStart: "",
    mtgDateEnd: "",
    mtgIs: "before",
    content: "",
    page:"zentei",
    add:false,
    authModal: false,
    defaultAuthView: "chooseauth",
    profileModal:false,
    profImageS:"",
    contentUpdatedAt: '',
    attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    data_location_lat: Number(process.env.VUE_APP_LOCATION_LAT || 35.6813320349034),
    data_location_lng: Number(process.env.VUE_APP_LOCATION_LNG || 139.76716771167693),
    latlngInput: {},
    markers: {lat: 0, lng: 0},
    locate: {lat: 0, lng: 0},
    overlay: false,
    zIndex: 0,
  }),
  computed: {
    logoSrc() {
      return this.$store.state.logoSrc;
    },
    members(){
      return this.$store.state.members
    },
    namelist(){
      return this.$store.state.namelist
    },
    isAdmin(){
      return this.$store.state.isAdmin
    },
    lid(){
      return this.$store.state.lid
    },
    alid(){
      return this.$store.state.alid
    },
    navlid(){
      let navlid = []
      let alid = this.$store.state.alid
      this.$store.state.navlid.forEach((el)=>{
        if(el.isfolder===true){
          el.childlids.forEach((el2)=>{
            navlid.push(el2)
          })
        } else {
          navlid.push(el)
        }
      })
      if(alid.length>0) navlid = navlid.concat(alid)
      return navlid
    },
    config(){
      return this.$store.state.config
    },
    basetitle(){
      return this.$store.state.basetitle
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
  },
  created() {
    this.db = firebase.firestore() // dbインスタンスを初期化
  },
  mounted(){
    if(this.$mq !== 'sp'){
      this.$router.push('/home')
    }
    this.markers = {lat: this.data_location_lat, lng: this.data_location_lng}
    this.locate = {lat: this.data_location_lat, lng: this.data_location_lng}
    this.getMtg()
  },
  methods: {
    dateFormatter(start, end) {
      const yearStart = start.slice(0, 4)
      const monthStart = start.slice(5, 7).replace(/^0+/, '')
      const dayStart = start.slice(8, 10).replace(/^0+/, '')
      const hourStart = start.slice(11, 13).replace(/^0+/, '')
      const minuteStart = start.slice(14, 16).replace(/^0+/, '')
      const yearEnd = end.slice(0, 4)
      const monthEnd = end.slice(5, 7).replace(/^0+/, '')
      const dayEnd = end.slice(8, 10).replace(/^0+/, '')
      const hourEnd = end.slice(11, 13).replace(/^0+/, '')
      const minuteEnd = end.slice(14, 16).replace(/^0+/, '')
      if (!hourStart.length||!minuteStart.length) {
        // 終日の場合
        if (start.slice(0,10) == end.slice(0,10)) {
          // 日時が同じ場合なので、終了の日付は省略
          return yearStart + "年" + monthStart + "月" + dayStart + "日 終日"
        } else if ( yearStart == yearEnd && monthStart == monthEnd) {
          // 年と月が同じ場合は重複する年と月を省略
          return yearStart + "年" + monthStart + "月" + dayStart + "日 - " + dayEnd + "日"
        } else if (yearStart == yearEnd) {
          // 年が同じ場合は重複する年を省略
          return yearStart + "年" + monthStart + "月" + dayStart + "日 - " + monthEnd + "月" + dayEnd + "日"
        } else {
          // 年が異なる場合は年月日をすべて表示
          return yearStart + "年" + monthStart + "月" + dayStart + "日 - " + yearEnd + "年" + monthEnd + "月" + dayEnd + "日"
        }
      } else {
        // 終日でない場合
        if (start.slice(0,10) == end.slice(0,10)) {
          // 日時が同じ場合なので、終了の日付は省略
          return yearStart + "年" + monthStart + "月" + dayStart + "日 " + hourStart + ":" + minuteStart + " - " + hourEnd + ":" + minuteEnd
        } else if ( yearStart == yearEnd && monthStart == monthEnd) {
          // 年と月が同じ場合は重複する年と月を省略
          return yearStart + "年" + monthStart + "月" + dayStart + "日 " + hourStart + ":" + minuteStart + " - " + dayEnd + "日 " + hourEnd + ":" + minuteEnd
        } else if (yearStart == yearEnd) {
          // 年が同じ場合は重複する年を省略
          return yearStart + "年" + monthStart + "月" + dayStart + "日 " + hourStart + ":" + minuteStart + " - " + monthEnd + "月" + dayEnd + "日 " + hourEnd + ":" + minuteEnd
        } else {
          // 年が異なる場合は年月日をすべて表示
          return yearStart + "年" + monthStart + "月" + dayStart + "日 " + hourStart + ":" + minuteStart + " - " + yearEnd + "年" + monthEnd + "月" + dayEnd + "日 " + hourEnd + ":" + minuteEnd
        }
      }
    },
    getMtg(){
      let self = this
      self.mtgs = []
      this.db.collection("0").doc("config").collection("mtg").orderBy("sort", "desc").get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let oneno = doc.data()
          //console.log("mtg",oneno)
          if(oneno.isActive) self.mtgs.push(oneno)
        })
      })
    },
    setLocate(){
      if(this.config&&this.config.location){
        this.locate.lat = this.config.location.lat
        this.locate.lng = this.config.location.lng
      }
    },
    signout() {
      this.$store.dispatch("auth/logout");
    },
    closeAuthModal() {
      this.authModal = false
    },
    closeProfile() {
      this.profileModal = false;
    },
    closeNotify(){
      this.notify = false
    },
    getIconWithColor(tagColor, iconType='flag') {
      const color = tagColor || '#126fc6';
      const icon = L.divIcon({
        html: 
          iconType == 'flag'
          ?
            `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="_x32_" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 512 512" style="width: 32px; height: 32px; opacity: 1;" xml:space="preserve"><g><rect x="144" class="st0" width="320" height="240" style="fill: ${color}" stroke="white" stroke-width="20" stroke-linecap="round""/><rect x="48" class="st0" width="64" height="512" style="fill: ${color}" stroke="white" stroke-width="20" stroke-linecap="round""/></g></svg>`
          :
            `<svg version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="width: 32px; height: 32px; opacity: 1;" xml:space="preserve"><g><path class="st0" d="M256.102,275.689c-13.136,0-26.131-2.015-38.62-5.994l-2.073-0.66v203.275c0,5.792,2.199,11.289,6.227,15.512 l17.453,17.216c4.276,4.488,10.047,6.96,16.246,6.96c6.202,0,11.97-2.473,16.211-6.926l17.525-17.286 c3.992-4.192,6.19-9.685,6.19-15.477V269.556l-2.052,0.625C281.193,273.838,268.709,275.689,256.102,275.689z" style="fill: ${color};"></path><path class="st0" d="M255.999,0c-68.961,0-125.063,56.106-125.063,125.069c0,68.959,56.102,125.065,125.063,125.065 s125.065-56.106,125.065-125.065C381.064,56.106,324.96,0,255.999,0z M217.269,126.047c-20.052,0-36.366-16.312-36.366-36.366 c0-20.05,16.314-36.362,36.366-36.362s36.366,16.312,36.366,36.362C253.635,109.735,237.321,126.047,217.269,126.047z" style="fill: ${color};"></path></g></svg>`
          ,
        iconAnchor: [3, 34],
        className: 'dummy' // これがないとデフォルトのleaflet-div-iconが適用されてしまう
      })
      return icon
    },
    getIdea(){ //アイデア取得
      let self = this, oneidea = {}
      this.idea = []
      this.mapLid.forEach((el)=>{
        console.log(el)
        let collection = this.db.collection("0").doc(el).collection("idea").where("isActive", "==", true).where("isHidden", "==", false).where('latlngInputLat', "!=", 0)
        collection.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            oneidea = doc.data()
            console.log(oneidea)
            self.$set(oneidea,"id",doc.id)
            self.$set(oneidea,"lidId",el) //どのLidかわかるように
            if(oneidea.isActive) self.idea.push(oneidea)
          })
          self.showedIdeaInMap()
        })
        console.log("アイデア",this.idea)
      })
    },
    showedIdeaInMap() {
      this.showedIdeaInMap_dict =[]
      for (let i = 0; i < this.idea.length; i++){
        if(this.idea[i].latlngInputLat!=0){
          this.showedIdeaInMap_dict.push({
            ...this.idea[i],
            icon: this.getIconWithColor(this.idea[i].postcolor)
          })
        }
      }
    },
  }
}
</script>
<style scoped>
.add-btn{
  position: fixed;
  right: 40px;
  bottom: 160px;
  z-index: 10;
}
</style>